"use client";

import Link from "next/link";

interface DirectoryCardProps {
    id: number;
    name: string;
    type: string;
    status: string;
    regionCode: string;
    description: string;
    url: string;
    visible: boolean;
    volunteerCount?: number;
    activeCount?: number;
    inactiveCount?: number;
    communityCount?: number;
    editUrl?: string;
}

export default function DirectoryCard({
    name, type, status, regionCode, description, url, visible,
    communityCount = 0, editUrl
}: DirectoryCardProps) {
    if (!visible) return null;

    return (
        <div
            className="groups-card"
            data-type={type}
            style={{ position: "relative", zIndex: 1 }}
        >
            <Link href={url} style={{ textDecoration: "none", color: "inherit", display: "block" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.35rem" }}>
                    <span className={`card-badge ${type}`}>
                        {type.charAt(0).toUpperCase() + type.slice(1)}
                    </span>
                    {type === "chapter" && regionCode && (
                        <span className="card-region-code">{regionCode}</span>
                    )}
                </div>
                <h3 className="card-title">{name}</h3>
                {description && <p className="card-desc">{description}</p>}
            </Link>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "1rem" }}>
                <span className="card-status">
                    <span className="card-status-dot" />
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                </span>

                <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
                    {type === "chapter" && communityCount > 0 && (
                        <span className="text-[0.65rem] font-bold text-[#ae232d] bg-[#ae232d]/10 px-2 py-1 rounded-full border border-[#ae232d]/20">
                            {communityCount} {communityCount === 1 ? "Community" : "Communities"}
                        </span>
                    )}
                    {editUrl && (
                        <Link href={editUrl}>
                            <button style={{
                                backgroundColor: "transparent", border: "1px solid #007a8a", color: "#007a8a",
                                padding: "0.15rem 0.5rem", borderRadius: "4px", fontSize: "0.65rem",
                                fontWeight: "bold", cursor: "pointer", textTransform: "uppercase"
                            }}>
                                Edit
                            </button>
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}
